
import { User } from "@supabase/supabase-js";
import { CalligraphyForm } from "@/components/CalligraphyForm";
import { useCredits } from "@/hooks/useCredits";

interface MainContentProps {
  user: User | null;
  generatedSvg: string | null;
  setGeneratedSvg: (svg: string | null) => void;
}

export const MainContent = ({ user, generatedSvg, setGeneratedSvg }: MainContentProps) => {
  const { credits } = useCredits(user);

  return (
    <div className="w-full flex justify-center px-4 md:px-0">
      <div className="w-full md:w-[70%] pb-16">
        {user && (
          <div className="rounded-lg">
            <CalligraphyForm 
              user={user} 
              generatedSvg={generatedSvg} 
              setGeneratedSvg={setGeneratedSvg}
            />
          </div>
        )}
      </div>
    </div>
  );
};
